import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-download",
  "use": "icon-icon-download-usage",
  "viewBox": "0 0 100 100",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 100 100\" id=\"icon-icon-download\"><g><path d=\"M78.9,47.5c2-2,2-5.4,0-7.4L77.8,39c-2-2-5.4-2-7.4,0l-14,14V11.6c0-3.3-2.7-5.9-5.9-5.9h-0.2c-3.3,0-5.9,2.7-5.9,5.9v41.2   L30.6,39c-2-2-5.4-2-7.4,0L22.1,40c-2,2-2,5.4,0,7.4l28.4,28.4L78.9,47.5z\" /></g><g><path d=\"M82.2,94.7H18.8c-3,0-5.5-2.5-5.5-5.5s2.5-5.5,5.5-5.5h63.4c3,0,5.5,2.5,5.5,5.5S85.2,94.7,82.2,94.7z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol